<template>
  <footer class="footerWrap" :class="{ bookStyle: bookStyle }">
    <div class="row-wrap custom-container">
      <div class="row-left">
        <a href="mailto:service@astroinfo.com.tw">
          <div class="email">
            <img src="@/assets/運勢書共用/social_email.svg" v-if="bookStyle" />
            <img src="@/assets/icon_email.svg" v-else />
          </div>
        </a>
        <div class="links">
          <div class="link" @click="toReport">问题回报</div>
          <div class="link" @click="toPrivacy">隐私及服务条款</div>
        </div>
      </div>
    </div>
    <div class="copyright">
      <span>
        © ASTRORG 星学会展示网站。 本网站仅供业务开发、合作提案与产品展示使用。网站内容包含客制化星盘服务、产品概念、流量变现模型与合作案例示意；相关数据已依保密原则进行汇整或比例化处理，仅供潜在合作伙伴评估参考。实际服务内容、合作条件、授权方式与商业模式，将以双方正式合同为准。
      </span>
    </div>
  </footer>
</template>
<script>
export default {
  data() {
    return {};
  },
  computed: {
    bookStyle() {
      const bookRegex = /^\/book202[4-7]/;
      return bookRegex.test(this.$route.path);
    },
  },
  methods: {
    toPrivacy() {
      this.$router.push({ path: "/privacy-policy" });
    },
    toReport() {
      this.$router.push({ path: "/report" });
    },
  },
};
</script>
<style lang="scss">
@import "@/scss/_mixin.scss";

.footerWrap {
  margin-top: 44px;
  background-color: #19112b;
  border-radius: 0;
  border-top: 1px solid rgba(238, 109, 175, 0.15);
  height: auto;
  box-shadow: none;

  @include laptop {
    height: auto;
  }
  .row-wrap {
    @include align(space-between, center);
    height: 180px;
    @include laptop {
      flex-direction: column;
      padding: 0px 16px 30px;
      height: auto;
    }
    @include mobile {
      padding: 24px 16px 16px;
    }
  }
  .row-left {
    @include align(flex-start, center);
  }
  .email {
    width: 160px;
    height: 160px;
    margin-right: 87px;
    cursor: pointer;
    img {
      width: 100%;
      height: 100%;
      filter: brightness(0) invert(1) sepia(1) saturate(5) hue-rotate(290deg);
    }
    @include laptop {
      margin-right: 32px;
    }
    @include mobile {
      width: 50px;
      height: 50px;
    }
  }
  .links {
    font-size: 24px;
    line-height: 1.5;
    letter-spacing: 0.96px;
    color: rgba(255, 255, 255, 0.7);
    cursor: pointer;
    .link {
      margin-bottom: 8px;
      transition: 0.3s;
      &:hover {
        color: $theme-color-1;
      }
      &:last-child {
        margin-bottom: 0;
      }
    }
    @include laptop {
      display: flex;
      .link {
        margin-bottom: 0px;
        margin-right: 30px;
        &:last-child {
          margin-right: 0;
        }
      }
    }
    @include mobile {
      font-size: 14px;
    }
  }
  .copyright {
    @include center;
    width: 100%;
    min-height: 84px;
    background-color: rgba(238, 109, 175, 0.05);
    border-top: 1px solid rgba(238, 109, 175, 0.1);
    text-align: center;
    font-size: 14px;
    font-weight: 100;
    line-height: 1.6;
    letter-spacing: 0.6px;
    color: rgba(255, 255, 255, 0.5);
    padding: 12px 20px;
    @include mobile {
      font-size: 11px;
      min-height: 56px;
      padding: 10px 12px;
    }
  }
}

.bookStyle.footerWrap {
  position: relative;
  z-index: 1;
  background-color: #19112b;
  box-shadow: none;
  border-top: 1px solid rgba(238, 109, 175, 0.15);
  .links {
    color: #fff;
  }
  .copyright {
    background-color: rgba(238, 109, 175, 0.05);
    color: rgba(255, 255, 255, 0.5);
  }
}
</style>
